export default "__VITE_PUBLIC_ASSET__0160290e__"